export default "__VITE_ASSET__CzhPqMV4__"